import { inject, Injectable, signal, Signal } from '@angular/core';
import { Dictionary, ReadonlyRepositoryCollectionService, Result } from '@softline/core';
import { MilchartikelRepository } from '../repositories/milchartikel.repository';
import { Artikel } from '../data/product';

@Injectable()
export class MilchartikelService extends ReadonlyRepositoryCollectionService<
  Artikel,
  Result<Artikel[]>,
  Dictionary<unknown> | undefined
> {
  override params: Signal<Dictionary<unknown> | undefined> = signal({});

  constructor() {
    super(inject(MilchartikelRepository));
  }

  protected override getAll(result: Result<Artikel[]> | null | undefined): Artikel[] {
    return result?.result ?? [];
  }
}
